export default __webpack_public_path__ + "static/media/350.00f4a1ba.jpg";